 <!-- <router-outlet></router-outlet> -->

 <div class="loader"></div>
<div class="main-body-content">

    <div id="app">

        <div class="main-wrapper main-wrapper-1 main_container" *ngIf="templateAuthView == false">
                    <div class="" style="background-image: url(./assets/img/bg1-min.png);background-repeat: no-repeat;
    background-size: cover;background-position: center;">
            <div class="navbar-bg"></div>
            <div class="main-content" *ngIf="templateAuthView == false">
                <section class="section">
                    <router-outlet (activate)="onActivate($event)"></router-outlet>
                </section>
            </div>
           
        </div>
        </div>
        <div class="main-body-auth" *ngIf="templateAuthView == true">
            <div class="" style="background-image: url(./assets/img/bg1-min.png);background-repeat: no-repeat;
    background-size: cover;background-position: center;">
            <router-outlet (activate)="onActivate($event)"></router-outlet>
            </div>
        </div>

    </div>
</div>